require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./higher-ed-solutions.json") })
        }
      }, "path---higher-ed-solutions");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---higher-ed-solutions!./.cache/json/higher-ed-solutions.json
// module id = 1209
// module chunks = 231608221292675